var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65136 15C6.40008 15 6.18982 14.9153 6.02058 14.7461C5.85135 14.5769 5.76673 14.3666 5.76673 14.1153V8.32688L0.168684 1.21538C-0.0236161 0.95896 -0.0514992 0.692293 0.0850341 0.415376C0.221567 0.13846 0.452009 0 0.776359 0H13.7571C14.0814 0 14.3119 0.13846 14.4484 0.415376C14.5849 0.692293 14.557 0.95896 14.3647 1.21538L8.76668 8.32688V14.1153C8.76668 14.3666 8.68207 14.5769 8.51283 14.7461C8.3436 14.9153 8.13334 15 7.88206 15H6.65136ZM7.26671 7.79998L12.2167 1.49998H2.31671L7.26671 7.79998Z",
    fill: "#35353A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.fc55e778c3d7b3089fd71ea6187a6f5a.svg";
export { ForwardRef as ReactComponent };